var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"config":_vm.config,"data":_vm.logs,"filter":'',"filterBy":'name',"sortByKey":'name',"sorDirection":'ASC',"updateSort":o=> o,"showHeader":false,"isRowClickable":() => false}},[_c('h2',{staticClass:"table--no-content",attrs:{"slot":"empty-table"},slot:"empty-table"},[_vm._v(_vm._s(_vm.$t("All emails sent successfully")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }